import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeader from '@/components/base/SectionHeader';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => b.updateTime.localeCompare(a.updateTime))
    .slice(0, 6);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeader
        title="最新更新"
        subtitle="每天都有新章节上线，第一时间开读"
        moreTo="/category?sort=new"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
        {latest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}